export const core = {
  title: 'Casino Powerbet',
  titleCasino: 'Casino',
};
